class ChangeQuizController {

    constructor() {
        this.template = Handlebars.compile($("#worldChangeQuizScreen").html());
        this.menuTemplate = Handlebars.compile($("#fullModalMenu").html());

        $(document).on("click", '.changeQuizBtn', function() {
            let access_token = $(this).attr('access-token');
            let world_token = $(this).attr('world-token');
            ChangeQuizController.closeQuiz(access_token, world_token);
            return false;
        });

    }

    static closeQuiz(access_token, token, tab_id = null, callback = null) {
        docSocket = null;
        chartSocket = null;
        socketRequest.disconnect();
        socketResponse.disconnectListeners();

        // Se reiniciar el valor de la documentacion para poder guardar el del nuevo quiz.
        documentationScreenController.documentation = null;
        documentationScreenController.documentsAsResources = {};
        clearInterval(documentationScreenController.setDocumentationInterval);

        if(quizSocket != null){
            quizSocket.close();
            quizSocket = null;
        }

        ChangeQuizController.changeQuiz(access_token, token, tab_id, callback);

        return false;
    }

    static changeQuiz(access_token, token, tab_id, callback) {
        storage.removeItem('translation_version');
        baseController.cssCreated = false;

        // Set target world context BEFORE login so all auth headers are consistent:
        // - localStorage.access_token → WSSE credential for the new world
        // - world.token / keycloakAuth.worldToken → world-token header and request body world_token
        storage.setItem('access_token', access_token);
        if (typeof keycloakAuth !== 'undefined') {
            keycloakAuth.worldToken = token;
        }
        if (typeof world !== 'undefined') {
            world.token = token;
        }

        api.login(
            window.blackBox.getAvatar(),
            window.blackBox.getPhrase(),
            true,
            null,
            false,
            false,
            tab_id,
            () => {
                localStorage.setItem('kc_world', token);

                if (callback) {
                    callback();
                }

                setTimeout(() => {
                    window.location.href = '/';
                }, 50);
            }
        );
    }
    
    draw() {
        baseController.resetStackableOrder();

        let sectionTitle = Translator.trans('TR_MIS_QUIZFITS');
        const worldTabs = world?.world_tabs ?? [];

        for(let i in worldTabs){
            if(world.world_tabs[i].id === 10){
                sectionTitle = world.world_tabs[i].name;
            }
        }

        baseController.stackSimpleMenu({ sectionTitle: sectionTitle }, this.menuTemplate);
        
        let context  = { user: user, world: world };
        baseController.stackSimpleContent(this.template, context, 'CONTENT');

        let height = 50;

        if ($(window).width() <= 420) {
            height = 40;
        }

        $('.changeQuiz .list-group-item-name h2').dotdotdot({
            wrap: 'word',
            watch: true,
            height: height
        });

        setTimeout(ChangeQuizController.adjustHeight.bind(this), 50);
    }

    static adjustHeight() {
        let wrapper = $('.changeQuiz div.wrapper');
        let wrapperTop = wrapper?.offset()?.top ?? 40;
        let wrapperBottom = wrapperTop + wrapper.outerHeight();

        let windowHeight = $(window).height();

        let diff = windowHeight - wrapperBottom;
        if (diff > 0) {
            let wrapperHeight = wrapper.outerHeight();
            wrapper.outerHeight(wrapperHeight + diff);
        }

    }
}
